import React from 'react';
import HelpIcon from '@material-ui/icons/Help';

import { PropTypes } from 'helpers/react';
const { element, children, string } = PropTypes;

import styles from './styles/index';
import cx from 'classnames';

export default class HelpText extends React.Component {
  static propTypes = {
    icon: element,
    children: children.isRequired,
    className: string
  };
  static defaultProps = {
    icon: <HelpIcon />
  };
  render() {
    return (
      <div
        className={
          this.props.className
            ? cx(styles['helpTextRow'], this.props.className)
            : styles['helpTextRow']
        }
      >
        {this.props.icon}&nbsp;
        <span className={styles['helpTextRow__text']}>
          {this.props.children}
        </span>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/client/shared-components/HelpText/index.js